module.exports = __webpack_public_path__ + "static/media/empty_filter_mobile.63cc4053.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty_filter_mobile.svg
// module id = 759
// module chunks = 11